module.exports = __webpack_public_path__ + "static/img/ramka_czerwona.1ebe69cc.png";